<template>
    <div class="d-flex flex-column justify-content-start align-items-start content">
        <h1>Manage Unclaimed Artist</h1>
        <section>
            <h2>Upload Artist Infos</h2>
            <form @submit.prevent="uploadFile">
                <input
                    @change="onFileChange"
                    class="btn btn-primary"
                    type="file"
                    accept=".csv"
                />
                <button type="submit" class="btn btn-secondary">Upload</button>
            </form>
            <button
                class="btn btn-danger mt-2"
                id="archive-selected-user"
                data-placement="left"
                data-singleton="true"
                @click="modalActive"
            >
                User Actions
            </button>
            <div v-if="uploadMessage">{{ uploadMessage }}</div>
        </section>
        <section class="w-100">
            <h2>Unclaimed Artist Infos</h2>
            <input
                id="users-search-input"
                type="text"
                v-model="searchValue"
                class="form-control-search main-form-control @error('search') is-invalid @enderror"
                name="search"
                placeholder="Search by Artist Name, Email"
            />
            <b-table
                class="table-responsive"
                id="allUsersTable"
                :items="filteredArtistInfos"
                :fields="fields"
                responsive="lg"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template v-slot:cell(select)="{ item }">
                    <input type="checkbox" :value="item" v-model="checked" />
                </template>
                <template v-slot:cell(claim)="{ item }">
                    <button
                        type="button"
                        class="btn mb-1 btn-primary js-open-confirmation"
                        @click="claimProfile(item.id)"
                    >
                        Claim
                    </button>
                </template>
            </b-table>
            <div v-if="claimMessage">{{ claimMessage }}</div>
        </section>
        <ModalActions
            v-if="activeModal"
            :selected-users="checked"
            @close-modal="activeModal = false"
        />
    </div>
</template>

<script>
    import ModalActions from './modal-actions-window.vue'

    export default {
        name: 'VueUnclaimedProfiles',
        components: {
            ModalActions
        },
        data() {
            return {
                file: null,
                uploadMessage: '',
                unclaimedArtistInfos: [],
                claimMessage: '',
                fields: [
                    'select',
                    { key: 'admin_id', sortable: true },
                    { key: 'band_name', sortable: true },
                    { key: 'unclaimed_email', sortable: true },
                    { key: 'claim', sortable: false }
                ],
                perPage: 50,
                currentPage: 1,
                searchValue: '',
                checked: [],
                activeModal: false,
                mode: ''
            }
        },
        computed: {
            filteredArtistInfos: (self) => {
                return self.unclaimedArtistInfos.filter((artistInfo) => {
                    return (
                        artistInfo.band_name
                            .toLowerCase()
                            .includes(self.searchValue.toLowerCase()) ||
                        artistInfo.unclaimed_email
                            .toLowerCase()
                            .includes(self.searchValue.toLowerCase())
                    )
                })
            }
        },
        async created() {
            await this.fetchUnclaimedArtistInfos()
        },
        methods: {
            modalActive() {
                this.activeModal = true
                this.mode = 'allUsers'
            },
            onFileChange(e) {
                this.file = e.target.files[0]
            },
            async uploadFile() {
                const formData = new FormData()
                formData.append('file', this.file)

                try {
                    const response = await axios.post(
                        '/admin/artist-profiles/upload',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    )
                    this.uploadMessage = response.data.message
                    await this.fetchUnclaimedArtistInfos()
                } catch (error) {
                    notification('error', 'Could not delete social link')
                    this.uploadMessage = 'Error uploading file'
                }
            },
            async fetchUnclaimedArtistInfos() {
                try {
                    const response = await axios.get('/admin/artist-profiles/get-unclaimed')
                    this.unclaimedArtistInfos = response.data
                } catch (error) {
                    console.error(error)
                    this.claimMessage = 'Error loading unclaimed artist infos'
                }
            },
            async claimProfile(artistInfoId) {
                try {
                    const userId = prompt('Enter the user ID to assign this profile to:')
                    if (userId) {
                        const response = await axios.post(
                            `/admin/artist-profiles/artist/assign/${artistInfoId}`,
                            { user_id: userId }
                        )
                        this.claimMessage = response.data.message
                        this.unclaimedArtistInfos = this.unclaimedArtistInfos.filter(
                            (info) => info.id !== artistInfoId
                        )
                    }
                } catch (error) {
                    console.error(error)
                    this.claimMessage = 'Error claiming artist info'
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .content {
        gap: 10px;
    }
</style>
